import { cx } from "@emotion/css";
import { useNavigate } from "react-router-dom";

import SolidAddIcon from "@/assets/solid-plus.svg?react";
import { Card } from "@/components";
import { setStorage } from "@/shared/store";
import type { Building } from "@/types";

interface BuildingSettingEntryCardProps {
  building: Building & { deviceCount: number };
  className?: string;
}
export const BuildingSettingEntryCard: React.FC<BuildingSettingEntryCardProps> = ({ building, className }) => {
  const navigate = useNavigate();
  const handleBuildingClick = () => {
    setStorage("configureDearisDevicesBuildId", building.build_id);
    setStorage("dearisBuildingDetail", {
      id: building.id,
      name: building.name,
    });
    navigate(`/dearis-building/${building.id}`);
  };
  return (
    <Card
      className={cx("mb-[16px] !rounded-[10px] !border-[1px] !border-solid !border-[#00AFCC] !bg-[#CCEFF5]", className)}
      onClick={handleBuildingClick}
    >
      <div className="flex w-full items-center justify-between">
        <div className="flex-1">
          <div className={cx("text-sm font-medium leading-none tracking-normal text-primary")}>
            {building?.name ?? "-"}
          </div>
          <div className={cx("mt-2 flex w-full", "text-xs font-normal leading-none tracking-normal text-primary")}>
            <span className="w-1/2">棟番号：{building?.build_id ?? "-"}</span>
            <span className="w-1/2 text-left">
              デバイス：
              <span className={cx(building?.deviceCount === 0 && "text-[#F51E1E]")}>
                {building?.deviceCount ?? "-"}
              </span>
            </span>
          </div>
        </div>
        <SolidAddIcon className={cx("ml-4 h-5 w-5 flex-shrink-0 text-[#C4CBCC]")} />
      </div>
    </Card>
  );
};
